module.exports = __webpack_public_path__ + "static/young-asia-girl-wearing-medical-face-mask-thumb-up-1305e1809285fa5648f9f22c2b7facb1.jpg";